import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { BuyerService } from '../../../core/api/buyer.service';
import { FormatHelperService } from '../../../core/helper/format-helper.service';
import { SiteHelperService } from '../../../core/helper/site.service';
import { DialogPaymentDetailsComponent } from '../../../shared/dialogs/dialog-payment-details/dialog-payment-details.component';
import { Cohort, Site } from '../../../shared/models';
import * as fromApp from '../../../store';

@Component({
  selector: 'fc-buyer-card',
  templateUrl: './buyer-card.component.html',
  styleUrls: ['./buyer-card.component.scss'],
})
export class BuyerCardComponent implements OnInit {
  @Input() site: Site;
  @Input() cohort: Cohort;
  @Input() selectedCohort: Cohort;

  @Output() buyerSelected: EventEmitter<Cohort> = new EventEmitter<Cohort>();

  destroyRef = inject(DestroyRef);

  twentyYearMark: string = null;
  twentyYearProjection: number = 0;
  simulatedTwentyYearProjection: number = 0;
  baseValuePerYear: number = 0;
  fixedPayment: number = 0;
  basePayment: number = 0;
  totalFixedPayment: number = null;
  annualRevenue: number = null;
  buyerFinancialData: any = null;

  showSimulation = false;

  getOpenAssetURL = BuyerService.getOpenAssetURL;

  constructor(
    readonly store: Store<fromApp.AppState>,
    public siteHelper: SiteHelperService,
    public dialog: MatDialog,
    public formatHelper: FormatHelperService
  ) {}

  newSliderValue(value: number) {
    let ratio = 1 + (value / 100);
    if (value !== 0) {
      this.simulatedTwentyYearProjection = this.totalFixedPayment + (this.baseValuePerYear * (Math.pow(ratio, 20) - Math.pow(ratio, Math.max(this.cohort.initialFixedYears, 1))) / (ratio - 1));
    } else {
      this.simulatedTwentyYearProjection = this.twentyYearProjection;
    }
  }

  ngOnInit(): void {
    this.showSimulation = this.cohort.initialFixedYears < 20;
    this.buyerFinancialData = this.site.getCohortFinancials(this.cohort.id);
    this.twentyYearMark = this.buyerFinancialData['year_site_end'];

    this.basePayment = this.buyerFinancialData['variable']['payment'] ? this.buyerFinancialData['variable']['payment'] : this.buyerFinancialData['fixed']['payment'];
    this.baseValuePerYear = this.basePayment * 12 / this.cohort.payPeriodCadence

    this.totalFixedPayment = this.buyerFinancialData['fixed']['total'] + this.buyerFinancialData['prorated']['total'];
    this.fixedPayment = this.buyerFinancialData['fixed']['payment'];

    this.twentyYearProjection = this.buyerFinancialData['total']['total'];
    this.annualRevenue = this.buyerFinancialData['annual']
    this.simulatedTwentyYearProjection = this.twentyYearProjection;
  }

  getRoundedValue(value: number): number {
    return Math.round(value / 100) * 100;
  }

  onBuyerCardClick(): void {
    this.buyerSelected.emit(this.cohort);
  }

  get buyerCardClass() {
    if (this.cohort === this.selectedCohort) {
      return 'selected';
    }
    return '';
  }

  get paymentFrequency() {
    switch (this.cohort.payPeriodCadence) {
      case 12:
        return 'Annually';
      case 6:
        return 'Semi-Annually';
      case 3:
        return 'Quarterly';
      case 1:
        return 'Monthly';
      default:
        return 'Unknown';
    }
  }

  openDetails() {
    this.dialog.open(DialogPaymentDetailsComponent, {
      panelClass: 'fc-yes-no-dialog',
      data: { site: this.site, cohort: this.cohort, financials: this.buyerFinancialData },
    });
  }
}
